import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {HeaderWelcomeButtonsForAnonymousUserComponent} from "./anonymous-user/header-welcome-buttons-for-anonymous-user.component";
import {HeaderWelcomeButtonsForAuthorizedUserComponent} from "./authorized-user/header-welcome-buttons-for-authorized-user.component";
import {
    IGameContextViewModel
} from "../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {HeaderWelcomeButtonsBox} from "./boxes/header-welcome-buttons.box";
import {CyClass} from "../../../../common/cy-classes";

interface HeaderWelcomeButtonsComponentProps {
    gameContext?: IGameContextViewModel;
}
@observer
export class HeaderWelcomeButtonsComponent extends OrbitComponent<HeaderWelcomeButtonsComponentProps> {
  render() {

      return (
          <HeaderWelcomeButtonsBox className={CyClass('cy-welcome-component')}>
              {
                  this.services.user.isAuthorized
                    ? (<HeaderWelcomeButtonsForAuthorizedUserComponent/>)
                    : (<HeaderWelcomeButtonsForAnonymousUserComponent gameContext={this.props.gameContext}/>)
              }
          </HeaderWelcomeButtonsBox>
      );
  }
}
